import captchaManager from './CaptchaManager'
import RecaptchaV2Driver from './drivers/RecaptchaV2Driver'
import RecaptchaV3Driver from './drivers/RecaptchaV3Driver'
import TurnstileDriver from './drivers/TurnstileDriver'

captchaManager.registerDriver('recaptcha_v2', RecaptchaV2Driver)
captchaManager.registerDriver('recaptcha_v3', RecaptchaV3Driver)
captchaManager.registerDriver('turnstile', TurnstileDriver)

export default captchaManager
